import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
//#region utils/cn.ts
const customTwMerge = extendTailwindMerge({ extend: {
	theme: {
		radius: [
			"none",
			"xs",
			"xs-sm",
			"sm",
			"sm-m",
			"m",
			"xl",
			"xxl",
			"round"
		],
		spacing: [
			"none",
			"xxxs",
			"xxs",
			"button-height",
			"xs",
			"sm",
			"md",
			"lg",
			"xl",
			"xxl",
			"xxxl"
		]
	},
	classGroups: {
		"font-size": [
			"text-heading-large",
			"text-heading-medium",
			"text-heading-small",
			"text-body-base",
			"text-body-medium",
			"text-body-small",
			"text-body-xsmall",
			"text-accent-large",
			"text-accent-medium",
			"text-accent-small",
			"text-brand-heading-display-lg",
			"text-brand-heading-display-sm",
			"text-brand-heading-h1",
			"text-brand-heading-h2",
			"text-brand-heading-h3",
			"text-brand-heading-h4",
			"text-brand-heading-h5",
			"text-brand-heading-h6",
			"text-brand-body-lg",
			"text-brand-body-md",
			"text-brand-body-sm",
			"text-brand-body-xs",
			"text-brand-accent-label",
			"text-brand-accent-overline-lg",
			"text-brand-accent-overline-sm"
		],
		"font-weight": [
			"font-body-regular",
			"font-body-medium",
			"font-heading-medium",
			"font-heading-semi-bold",
			"font-accent-semibold"
		],
		leading: [
			"leading-heading-large",
			"leading-heading-medium",
			"leading-heading-small",
			"leading-body-base",
			"leading-body-medium",
			"leading-body-small",
			"leading-body-xsmall",
			"leading-accent-large",
			"leading-accent-small",
			"leading-brand-heading-display-lg",
			"leading-brand-heading-display-sm",
			"leading-brand-heading-h1",
			"leading-brand-heading-h2",
			"leading-brand-heading-h3",
			"leading-brand-heading-h4",
			"leading-brand-heading-h5",
			"leading-brand-heading-h6",
			"leading-brand-body-lg",
			"leading-brand-body-md",
			"leading-brand-body-sm",
			"leading-brand-body-xs",
			"leading-brand-accent-overline",
			"leading-brand-accent-label"
		],
		shadow: [
			"shadow-elevation-overflow",
			"shadow-elevation-raised",
			"shadow-elevation-overlay",
			"shadow-elevation-element"
		],
		"text-color": [
			"text-text-primary",
			"text-text-secondary",
			"text-text-brand-button",
			"text-text-muted"
		]
	},
	conflictingClassGroups: { "font-size": ["leading"] }
} });
function cn(...inputs) {
	return customTwMerge(clsx(inputs));
}
//#endregion
export { cn };

//# sourceMappingURL=cn.js.map